import React from 'react';
import styled, { css } from 'styled-components';

const SectionContainer = styled.section`
  padding: ${props => props.small ? '3rem 0' : '5rem 0'};
  position: relative;
  overflow: hidden;
  
  ${props => props.gray && css`
    background-color: var(--background-gray);
  `}
  
  ${props => props.offWhite && css`
    background-color: var(--background-off-white);
  `}
  
  ${props => props.primary && css`
    background-color: var(--primary-color);
    color: white;
  `}
  
  ${props => props.primaryDark && css`
    background-color: var(--primary-dark);
    color: white;
  `}
  
  ${props => props.secondary && css`
    background-color: var(--secondary-color);
    color: var(--text-dark);
  `}
  
  ${props => props.accent && css`
    background-color: var(--accent-color);
    color: white;
  `}
  
  ${props => props.fullWidth && css`
    .container {
      max-width: 100%;
      padding: 0;
    }
  `}
  
  ${props => props.withOverlay && css`
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 1;
    }
    
    .container {
      position: relative;
      z-index: 2;
    }
  `}
  
  @media (max-width: 992px) {
    padding: ${props => props.small ? '2.5rem 0' : '4rem 0'};
  }
  
  @media (max-width: 768px) {
    padding: ${props => props.small ? '2rem 0' : '3rem 0'};
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const SectionTitle = styled.h2`
  text-align: ${props => props.centered ? 'center' : 'left'};
  margin-bottom: ${props => props.spaced ? '3rem' : '1.5rem'};
  max-width: ${props => props.narrow ? '700px' : '100%'};
  margin-left: auto;
  margin-right: auto;
  
  ${props => props.withLine && css`
    position: relative;
    padding-bottom: 1.5rem;
    
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      ${props => props.centered ? 'left: 50%; transform: translateX(-50%);' : 'left: 0;'}
      width: 100px;
      height: 3px;
      background-color: ${props => props.lineColor ? `var(--${props.lineColor}-color)` : 'var(--accent-color)'};
    }
  `}
  
  @media (max-width: 768px) {
    margin-bottom: ${props => props.spaced ? '2rem' : '1.25rem'};
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.25rem;
  text-align: ${props => props.centered ? 'center' : 'left'};
  margin-bottom: ${props => props.spaced ? '3rem' : '1.5rem'};
  max-width: ${props => props.narrow ? '700px' : '100%'};
  margin-left: auto;
  margin-right: auto;
  color: ${props => 
    props.light ? 'rgba(255, 255, 255, 0.8)' : 
    props.muted ? 'var(--text-light)' : 
    'inherit'
  };
  
  @media (max-width: 768px) {
    font-size: 1.125rem;
    margin-bottom: ${props => props.spaced ? '2rem' : '1.25rem'};
  }
`;

const Section = ({ 
  children, 
  title, 
  subtitle,
  titleProps = {},
  subtitleProps = {},
  id,
  className,
  ...props 
}) => {
  return (
    <SectionContainer id={id} className={className} {...props}>
      <Container>
        {title && <SectionTitle {...titleProps}>{title}</SectionTitle>}
        {subtitle && <SectionSubtitle {...subtitleProps}>{subtitle}</SectionSubtitle>}
        {children}
      </Container>
    </SectionContainer>
  );
};

export default Section; 